import findInObject from '../findInObject'

/**
 * replaceParser
 *
 * This is a content filter function. It receives content,
 * obj, and originalMatch from the shortcodeParser.
 *
 * The purpose of this function is to replace "replace" shortcodes
 * with the content provided in the shortcode. Likely, this content
 * would be in variable form.
 *
 * Replace requires two properties, shortcode and content.
 *
 * {{ shortcode: "replace", "content": "content" }}
 *
 * @param {string} content - The full chunk of content
 * @param {object} obj - The shortcode as a JS object
 * @param {string} originalMatch - The original match, useful for replacing the shortcode
 *
 * @returns {string} content
 */
const replaceParser = (content, obj, originalMatch) => {
  const objType = findInObject('shortcode', obj)

  if (objType === 'replace') {
    const updatedContent = findInObject('content', obj)
    content = content.replace(originalMatch, updatedContent)
  }

  return content
}

export default replaceParser
